import { HTTP } from "@/axios"

export default {
    data() {
        return {
            deviceInfo: {
                browser: this.getBrowserInfo(),
                os: this.getOSInfo(),
                deviceType: this.getDeviceType(),
                orientation: window.innerWidth > window.innerHeight ? 'Landscape' : 'Portrait',
                screenWidth: window.innerWidth,
                screenHeight: window.innerHeight,
                ip: 'Cargando...',
                location: 'Cargando...',
                ipLocation: 'Cargando...',
                latitude: null,
                longitude: null,
                dispositivo_cliente: this.getBrowserInfo() + ', ' + this.getOSInfo() + ', ' + this.getDeviceType(),
                ip_cliente: ''
            }
        }
    },
    created() {
        window.addEventListener('resize', this.actualizarInfoDispositivo);
        this.obtenerIP();
        this.obtenerGeolocalizacion();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.actualizarInfoDispositivo);
    },
    methods: {
        getBrowserInfo() {
            const userAgent = navigator.userAgent;
            let browserName = "Desconocido";
            
            if (userAgent.includes("Edg/")) {
                browserName = "Microsoft Edge";
            }
            else if (userAgent.includes("Chrome") && !userAgent.includes("Edg/")) {
                browserName = "Google Chrome";
            }
            else if (userAgent.includes("Firefox")) {
                browserName = "Mozilla Firefox";
            }
            else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
                browserName = "Safari";
            }
            else if (userAgent.includes("OPR") || userAgent.includes("Opera")) {
                browserName = "Opera";
            }
            else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
                browserName = "Internet Explorer";
            }
            
            return browserName;
        },
        getOSInfo() {
            const userAgent = navigator.userAgent;
            let osName = "Desconocido";
            
            if (userAgent.match(/win/i)) {
                osName = "Windows";
            } else if (userAgent.match(/mac/i)) {
                osName = "MacOS";
            } else if (userAgent.match(/linux/i)) {
                osName = "Linux";
            } else if (userAgent.match(/android/i)) {
                osName = "Android";
            } else if (userAgent.match(/ios/i)) {
                osName = "iOS";
            }
            
            return osName;
        },
        getDeviceType() {
            const userAgent = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
                return "Tablet";
            }
            if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(userAgent)) {
                return "Móvil";
            }
            return "Escritorio";
        },
        async obtenerIP() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.deviceInfo.ip = data.ip;
                this.deviceInfo.ip_cliente = data.ip;
                await this.obtenerGeolocalizacionIP(data.ip);
            } catch (error) {
                console.error('Error al obtener IP:', error);
                this.deviceInfo.ip = 'No disponible';
                this.deviceInfo.ip_cliente = 'No disponible';
            }
        },
        async obtenerGeolocalizacionIP(ip) {
            try {
                const response = await fetch(`https://ipapi.co/${ip}/json/`);
                const data = await response.json();
                
                if (data.error) {
                    this.deviceInfo.ipLocation = 'No disponible';
                } else {
                    const location = [];
                    if (data.city) location.push(data.city);
                    if (data.region) location.push(data.region);
                    if (data.country_name) location.push(data.country_name);
                    this.deviceInfo.ipLocation = location.join(', ');
                    
                    if (data.latitude && data.longitude) {
                        this.deviceInfo.latitude = data.latitude;
                        this.deviceInfo.longitude = data.longitude;
                    }
                }
            } catch (error) {
                console.error('Error al obtener geolocalización IP:', error);
                this.deviceInfo.ipLocation = 'No disponible';
            }
        },
        obtenerGeolocalizacion() {
            if ("geolocation" in navigator) {
                const options = {
                    enableHighAccuracy: true, // Solicitar la mejor precisión posible
                    timeout: 10000, // Esperar hasta 10 segundos
                    maximumAge: 0 // No usar caché
                };

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        this.deviceInfo.location = `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
                        this.deviceInfo.latitude = latitude;
                        this.deviceInfo.longitude = longitude;
                    },
                    (error) => {
                        console.error('Error al obtener geolocalización:', error);
                        let mensaje = 'No disponible';
                        switch(error.code) {
                            case error.PERMISSION_DENIED:
                                mensaje = 'Permiso denegado. Por favor, habilite la geolocalización en su navegador.';
                                break;
                            case error.POSITION_UNAVAILABLE:
                                mensaje = 'La información de ubicación no está disponible.';
                                break;
                            case error.TIMEOUT:
                                mensaje = 'La solicitud de ubicación ha expirado.';
                                break;
                        }
                        this.deviceInfo.location = mensaje;
                    },
                    options
                );
            } else {
                this.deviceInfo.location = 'Geolocalización no soportada por su navegador';
            }
        },
        actualizarInfoDispositivo() {
            this.deviceInfo.orientation = window.innerWidth > window.innerHeight ? 'Landscape' : 'Portrait';
            this.deviceInfo.screenWidth = window.innerWidth;
            this.deviceInfo.screenHeight = window.innerHeight;
        },
        getMapUrl() {
            if (this.deviceInfo.latitude && this.deviceInfo.longitude) {
                return `https://www.google.com/maps?q=${this.deviceInfo.latitude},${this.deviceInfo.longitude}`;
            }
            return '';
        },
        getCoordenadasFormateadas() {
            if (this.deviceInfo.latitude && this.deviceInfo.longitude) {
                return `${this.deviceInfo.latitude.toFixed(4)}, ${this.deviceInfo.longitude.toFixed(4)}`;
            }
            return 'No disponible';
        },
        async login() {
            // Obtener la información del dispositivo
            const deviceData = {
                browser: this.deviceInfo.browser,
                os: this.deviceInfo.os,
                deviceType: this.deviceInfo.deviceType,
                ip: this.deviceInfo.ip,
                location: this.deviceInfo.location
            };

            // Incluir esta información en tu petición de login
            const loginData = {
                // ... tus datos de login
                deviceInfo: deviceData
            };

            // Realizar la petición de login
            try {
                const response = await HTTP.post('/login', loginData);
                // ... manejar la respuesta
            } catch (error) {
                // ... manejar el error
            }
        }
    }
} 